import { Profile } from '@ringo/types'
import { TOptions } from 'i18next'
import { useTranslation as useT } from 'react-i18next'
import { useCallback, useMemo } from 'react'
import isNumber from 'lodash/isNumber'
import { LanguageDTOLangKeyEnum, WebI18NTranslationKeys } from '@ringo/shared'

export type TranslationKeys = WebI18NTranslationKeys
type TranslationOptions = Omit<TOptions, 'context'> & { context?: string }
export type TranslationFunc = (key: TranslationKeys, args?: TranslationOptions) => string
export const EnglishLangKey = 'en'
export const GermanLangKey = 'de'
export const SupportedLanguageKeys = ['de', 'en', 'es', 'it', 'fr', 'nl', 'pl', 'ru', 'tr', 'cz', 'ro', 'hu', 'hr']

export function useTranslation() {
    const { t, ...rest } = useT()

    const translate = useCallback((key: TranslationKeys, options?: TranslationOptions) => t(key, options), [t])

    const translateProfile = (profile?: Profile, includeProfileNumber: boolean = true) => {
        if (profile == null) {
            return ''
        }

        if (isNumber(profile)) {
            return includeProfileNumber ? `${translate('profile')} ${profile}` : translate('profile')
        } else if (profile === Profile.Tube) {
            return translate('tube')
        } else if (profile === Profile.SinterringAxial) {
            return translate('sinterRingAxial')
        } else if (profile === Profile.Sinterring) {
            return translate('sinterRing')
        }
        return ''
    }

    const supportedLanguages: { label: string; id: LanguageDTOLangKeyEnum }[] = useMemo(
        () => [
            { id: 'EN', label: 'English - EN' },
            { id: 'DE', label: 'Deutsch - DE' },
            { id: 'ES', label: 'Español - ES' },
            { id: 'FR', label: 'Français - FR' },
            { id: 'IT', label: 'Italiano - IT' },
            { id: 'PL', label: 'Polski - PL' },
            { id: 'NL', label: 'Dutch - NL' },
            { id: 'RU', label: 'Русский - RU' },
            { id: 'TR', label: 'Türkçe - TR' },
            { id: 'CZ', label: 'Čeština - CZ' },
            { id: 'RO', label: 'Română - RO' },
            { id: 'HU', label: 'Magyar - HU' },
            { id: 'HR', label: 'Hrvatski - HR' },
        ],
        []
    )

    return { t: translate, supportedLanguages, translateProfile, ...rest }
}
